module.exports = __webpack_public_path__ + "files/c7df684ffcb3525640b429bd2dabea81.png";